import { ApiClient } from "./ApiClient";

type StartParams = {
  investment_id: string;
  citizenship: "US_CITIZEN" | "INTERNATIONAL";
};

class InquiryClient extends ApiClient {
  async find(inquiryId: string) {
    const response = await this.get(`/v2/inquiries/${inquiryId}`);
    return response.data;
  }

  async findFull(inquiryId: string) {
    const response = await this.get(`/v2/inquiries/${inquiryId}/full`);
    return response.data;
  }

  async embed(data: StartParams) {
    const response = await this.post("/v2/inquiries/embed", data);
    return response.data;
  }

  async status(userId: string, inquiryId: string) {
    const response = await this.get(
      `/v2/inquiries/status/${userId}/${inquiryId}`,
    );

    return response.data;
  }

  async print(inquiryId: string) {
    const response = await this.get(`/v2/inquiries/${inquiryId}/print`, {
      responseType: "arraybuffer",
    });

    return response.data;
  }

  async resume(inquiryId: string) {
    const response = await this.post(`/v2/inquiries/resume/${inquiryId}`);

    return response.data;
  }

  async secondaries(investmentId: string) {
    const response = await this.post(
      `/v2/inquiries/secondaries/${investmentId}`,
    );

    return response.data;
  }

  async getInvestmentInquiries(investmentId: string, params?: object) {
    const response = await this.get(`/v2/inquiries/list/${investmentId}`, {
      params,
    });

    return response.data;
  }

  async emailInvestor(inquiryId: string, investmentId: string) {
    const response = await this.post(
      `/v2/inquiries/email/${investmentId}/${inquiryId}`,
    );

    return response.data;
  }

  async list(params: ListParams) {
    const response = await this.get("/v2/inquiries", { params });
    return response.data;
  }

  async remove(inquiryId: string) {
    await this.delete(`/v2/inquiries/${inquiryId}`);
  }

  async approve(investmentId: string, inquiryId: string, comment: string) {
    const response = await this.post(
      `/v2/inquiries/approve/${investmentId}/${inquiryId}`,
      { comment },
    );
    return response.data;
  }

  async decline(investmentId: string, inquiryId: string, comment: string) {
    const response = await this.post(
      `/v2/inquiries/decline/${investmentId}/${inquiryId}`,
      { comment },
    );
    return response.data;
  }

  async resetInquiry(investmentId: string, inquiryId: string) {
    const response = await this.delete(
      `/v2/inquiries/reset/${investmentId}/${inquiryId}`,
    );
    return response.data;
  }
}

export default InquiryClient;
